<template>
	<div class="container-fluid">
		<div class="page-header gold mt-4 mb-3">
			<back-btn></back-btn>
			<h2 class="mb-0">
				<i class="fas fa-umbrella-beach pr-2"></i> Sandpit
			</h2>
		</div>
		<DashboardUser :profile="profile"></DashboardUser>
	</div>
</template>

<script>
import DashboardUser from '../components/DashboardUser.vue';
import BackBtn from '@/components/BackBtn.vue';
export default {
	name: 'SandPit',
	components: {
		DashboardUser,
		BackBtn,
	},
	data() {
		return {};
	},
	computed: {
		profile() {
			return this.$store.getters.profileGet;
		},
	},
	methods: {},
	mounted() {},
	created() {},
	destroyed() {},
	watch: {},
};
</script>

<style scoped>
.page-header {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	position: relative;
	padding: 0 52px;
}
.page-header h2 {
	min-width: 0;
	text-align: center;
	word-break: break-word;
}
.gold {
	color: #d6b674;
}

</style>
